import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'breadcrumb-list',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  @Input("data") data:any         = null;
  @Input("showHome") showHome:any = true;

  public links = [{
    text: "Início",
    link: "/"
  }];

  constructor(
    private router: Router
  ){}

  /**
   * 
   * Navigate
   * 
   */
  _navigate(url){

    this.router.navigateByUrl(url); 

  }
  /**
   * 
   * Merge
   * 
   */
  _merge(){

    if(this.data != null){
      if(this.showHome == "true" || this.showHome == true){
        this.links = this.links.concat(this.data);
      }else{
        this.links = this.data;
      }
    }

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{
    this._merge();
  }


}
